/**
 * Stock Adjustment APIs (Draft → Authorize + Change Bin + Split Batch).
 * Uses inventory axios client — ORG-CODE resolves tenant/hospital server-side.
 */
import client from './inventory-request';
import { withStoreCreateBody, withStoreUpdateBody, getStoreActorId } from '../hooks/useStoreScope';

function actorPayload(extra = {}) {
  const actor = getStoreActorId();
  return actor ? { ...extra, created_by: extra.created_by || actor } : extra;
}

// ── Draft → Authorize adjustments ───────────────────────────────────────────

// API: POST /inventory/stock-adjustments/
export const createStockAdjustment = (body) =>
  client.post('/inventory/stock-adjustments/', withStoreCreateBody(body));

// API: GET /inventory/stock-adjustments/
export const getStockAdjustments = (p) =>
  client.get('/inventory/stock-adjustments/', p);

// API: GET /inventory/stock-adjustments/pending/
export const getPendingStockAdjustments = (p) =>
  client.get('/inventory/stock-adjustments/pending/', p);

// API: GET /inventory/stock-adjustments/{id}/
export const getStockAdjustment = (id) =>
  client.get(`/inventory/stock-adjustments/${id}/`);

// API: GET /inventory/stock-adjustments/{id}/items/
export const getStockAdjustmentItems = (id) =>
  client.get(`/inventory/stock-adjustments/${id}/items/`);

// API: PUT /inventory/stock-adjustments/{id}/
export const updateStockAdjustment = (id, body) =>
  client.put(`/inventory/stock-adjustments/${id}/`, withStoreUpdateBody(body));

// API: DELETE /inventory/stock-adjustments/{id}/  → CANCELLED
export const cancelStockAdjustment = (id) =>
  client.delete(`/inventory/stock-adjustments/${id}/`);

// API: POST /inventory/stock-adjustments/{id}/authorize/
export const authorizeStockAdjustment = (id, opts = {}) =>
  client.post(`/inventory/stock-adjustments/${id}/authorize/`, {
    authorized_by: opts.authorized_by || getStoreActorId() || undefined,
  });

// ── Change bin location ─────────────────────────────────────────────────────

// API: PUT /inventory/stock/bin-location/
export const changeStockBinLocation = (body) =>
  client.put('/inventory/stock/bin-location/', withStoreUpdateBody(body));

// ── Split batch ─────────────────────────────────────────────────────────────

// API: POST /inventory/stock/batches/split/
export const splitStockBatch = (body) =>
  client.post('/inventory/stock/batches/split/', withStoreCreateBody(actorPayload(body)));
